<h1 matDialogTitle>{{request ? 'Process EFT Refund Request' : 'Loading EFT Refund Request'}}</h1>

<mat-dialog-content>
  <ng-container *ngIf="request; else loading">
    <div>
      <table style="width: 100%;">
        <tr>
          <th class="th-label">Customer</th>
          <td class="td-value" style="text-align: left; padding-right: 16px;">{{request.customerCode}}</td>
          <th class="th-label">Balance (Acc.)</th>
          <td class="td-value" style="text-align: right;">{{request.customerAccountBalance | number:'1.2-2'}}</td>
        </tr>
        <tr>
          <th class="th-label">Sales Order</th>
          <td class="td-value" style="text-align: left; padding-right: 16px;">{{request.salesOrderNumber}}</td>
          <th class="th-label">Balance (Dep.)</th>
          <td class="td-value" style="text-align: right;">{{request.depositBalance | number:'1.2-2'}}</td>
        </tr>
        <tr *ngIf="request.invoiceNumber">
          <th class="th-label" style="vertical-align: top;">Invoice</th>
          <td class="td-value" style="text-align: left; padding-right: 16px;vertical-align: top;">
            {{request.invoiceNumber}}</td>
          <th class="th-label">Balance</th>
          <td class="td-value" style="text-align: right;">{{request.invoiceBalance | number:'1.2-2'}}</td>
        </tr>
        <tr>
          <th class="th-label">Request Type</th>
          <td class="td-value" style="text-align: left; padding-right: 16px;">{{request.requestType}}</td>
          <th class="th-label">Req. Amount</th>
          <td class="td-value" style="text-align: right;">{{request.amount | number:'1.2-2'}}</td>
        </tr>
      </table>
      <table style="margin-top: 32px;">
        <tr>
          <th class="th-label">Recipient</th>
          <td class="td-value">{{request.recipient}}</td>
        </tr>
        <tr>
          <th class="th-label">Bank</th>
          <td class="td-value">{{request.bank}}</td>
        </tr>
        <tr>
          <th class="th-label">Branch Code</th>
          <td class="td-value">{{request.branchCode}}</td>
        </tr>
        <tr>
          <th class="th-label">Account Number</th>
          <td class="td-value">{{request.accountNumber}}</td>
        </tr>
      </table>
    </div>


    <app-pos-capture-payment (paymentChanged)="paymentChanged($event)" (refundReasonChanged)="refundReasonChanged($event)" [paymentType]="request.paymentRequestType"
      [amountOutstanding]="request.amount" [salesOrderNumber]="request.salesOrderNumber" [invoiceNumber]="request.invoiceNumber" [eftRefundRequestId]="requestId">
    </app-pos-capture-payment>
  </ng-container>

  <ng-template #loading>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </ng-template>

</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button [matDialogClose]="undefined">Cancel</button>
  <button *ngIf="request" [disabled]="request.requestStatus !== 'PENDING' || blockUI" mat-button (click)="decline()">Decline</button>
  <button *ngIf="request" [disabled]="request.requestStatus !== 'PENDING' || !formValid || blockUI || !refundReasonId" mat-button
    (click)="processed()">Approve</button>
</mat-dialog-actions>
